<template>
    <div>
        <v-dialog v-model="pmrewardbonuspostinginstrucdialog" max-width="400px">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
            </template>
            <v-card style="overflow:visible;">
                <v-card-title style="position:sticky;top:0;z-index:10;">
                    <span class="headline">{{ isEdit ? $t('pmrewardrecord.editbonuspostinginstruc') : $t('pmrewardrecord.addbonuspostinginstruc') }}</span>
                </v-card-title>
                <v-card-text style="max-height:70vh;overflow-y:auto;">
                    <v-container>
                        <v-row>
                            <v-col cols="8" sm="8" md="8">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.effectivedate')"
                                    type="date"
                                    :rules="[rules.required]"
                                    dense
                                    v-model="formData.effectivedate"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n6">
                            <v-col cols="8" sm="8" md="8">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.percentage')"
                                    type="number"
                                    :rules="[rules.required]"
                                    dense
                                    v-model="formData.percentage"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{errMsg}}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closePmRewardRecordBonusPostingInstrucInput">{{$t('button.cancel')}}</v-btn>
                    <v-btn color="green darken-1" text @click="savePmRewardRecordBonusPostingInstrucInput">{{$t('button.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
:sort-by="['code']"
        >
            <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
                <v-icon
                    small
                    class="ml-3 mr-2"
                    @click="deleteItemHandler(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
        </div>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
                }"
                v-on:confirm="deleteItemHandlerAction"
                v-on:cancelConfirm="isConfirm = !isConfirm"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import moment from 'moment';

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                percentage: value => !(value < 0 || value > 100) || this.$t('reportsparam.valueonetohundred'),
            },

            pmrewardbonuspostinginstrucdialog: false,
            detailItem: this.parentObject.detailItem,
            pmassessmentrecordid: this.parentObject.pmassessmentrecordid,

            formData: {
                id: null,
                rewardrecordid: this.parentObject.rewardrecordid,
               
                effectivedate: null,
                percentage: null,
             
                rectimestamp: null,
                stamp: null,
                updatedby: this.$store.getters.userId,
            },
        
            isEdit: false,//default add new item, for the title
            isErr: false,
            errMsg: '',
            isConfirm: false,
            messageConfirm:'',
            selectedItem: null,
        }
    },

    methods: {
        newItem() {
            this.isExisting = false;
            this.modify = false;
            this.resetSelections();
        },

        modifyItemHandler(item) {
            this.isEdit = true;
            this.pmrewardbonuspostinginstrucdialog = true;
            this.formData = item;
        },

        deleteItemHandler(item) {
            this.messageConfirm = this.$t('pmrewardrecord.deleteConfirmWithDate', { date: item.effectivedate });
            this.selectedItem = item;
            this.isConfirm=true;
        },

        async deleteItemHandlerAction() {
            const vm = this;

            if (!this.selectedItem) {
                console.error("❌ No item selected for deletion!");
                return;
            }

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                console.error("❌ No permission to delete");
                return false;
            }

            try {
                await this.$store.dispatch('delete', {
                    url: "/pmrewardbonuspostinginstruc/" + vm.selectedItem.id
                });

                const index = vm.detailItem.findIndex(detail => detail.id === vm.selectedItem.id);
                if (index !== -1) {
                    vm.detailItem.splice(index, 1);
                }

                vm.selectedItem = null;  // 🔹 Clear after deletion
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error during deletion:", err);
            } finally {
                vm.isConfirm = false;  // 🔹 Close confirmation dialog
            }
        },

        async savePmRewardRecordBonusPostingInstrucInput() {
            try {
                if (this.isEdit) { // Edit
                    if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                        console.error("❌ No permission to edit");
                        return false;
                    }

                    if(this.formData.effectivedate) {
                        this.formData.effectivedate = moment(this.formData.effectivedate).format("YYYY-MM-DD");
                    }

                    const res = await this.$store.dispatch('put', {
                        url: "/pmrewardbonuspostinginstruc/" + this.formData.id,
                        payload: this.formData
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {
                        const updatedRecord = res.data.result;
                        if(updatedRecord.effectivedate) {
                            updatedRecord.effectivedate = moment(updatedRecord.effectivedate).format("YYYY-MM-DD");
                        }

                        const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                        if (index !== -1) {
                            this.$set(this.detailItem, index, updatedRecord);
                        } else {
                            console.warn("⚠️ Record not found in detailItem.");
                        }
                        this.pmrewardbonuspostinginstrucdialog = false;
                        this.isEdit = false;
                        this.resetSelections();
                    }
                } else { // Add
                    if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                        console.error("❌ No permission to add");
                        return false;
                    }
                    if(this.formData.effectivedate) {
                        this.formData.effectivedate = moment(this.formData.effectivedate).format("YYYY-MM-DD");
                    }

                    const res = await this.$store.dispatch('post', {
                        url: "/pmrewardbonuspostinginstruc/create",
                        payload: this.formData
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {
                        const insertedRecord = res.data.result;
                        if(insertedRecord.effectivedate) {
                            insertedRecord.effectivedate = moment(insertedRecord.effectivedate).format("YYYY-MM-DD");
                        }

                        this.detailItem.push(insertedRecord);
                        this.pmrewardbonuspostinginstrucdialog = false;
                        this.resetSelections();
                    }
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                console.error("❌ Error in processing:", err);
            }
        },

        closePmRewardRecordBonusPostingInstrucInput() {
            this.pmrewardbonuspostinginstrucdialog = false;
            this.isErr = false;
            this.isEdit = false;
            // reset the form fields
            this.resetSelections();
        },
                
        resetSelections() {
            this.formData = {
                id:null,
                rewardrecordid: this.parentObject.rewardrecordid,
                rectimestamp: null,
                stamp: null,
                updatedby: this.$store.getters.userId,

                effectivedate: null,
                percentage: null,
            };
        },
    },

    async mounted() {
        try {
            // no mounted 
        } catch (err) {
            this.isErr = true;
            this.errMsg = err.message || "An error occurred while loading data";
            console.error("❌ Error in mounted:", err);
        }
    },

}
</script>